module.exports = __webpack_public_path__ + "static/taskdriver-12ac40e1e6707e9fffed48989533f332.jpg";